import Splide from '@splidejs/splide'

const ELS = '.js-PhotosCarousel'

if(document.querySelector(ELS)){
  document.querySelectorAll(ELS).forEach(EL => {
    new Splide( EL , {
      autoWidth: true,
      arrows: true,
      pagination: false,
      drag: true,
      gap: 20
    }).mount()
  })
}
